import React, { Component } from 'react';
import './style.css';
import './Message.css';
import Linkify from 'react-linkify';

class Message extends Component {
	constructor(props) {
		super(props);

		this.state = { ...props };
	}

	render() {
		const index = this.props.index;
		const element = this.props.element;
		const isUser = (element.sender === 'user');
		if (element.audio) {
			return <div className="" key={"audio" + element.src}>
				<div className="info_container_send" style={{ "float": "left" }}>
					<audio controls src={element.src} style={{ "width": "auto" }}></audio>
				</div>
			</div>;
		} else {
			const msgVars = {
				containerClass: (isUser) ? "msg_container" : "msg_container_send",
				containerStyle: {
					float: (isUser) ? "right" : "left",
				},
				timeClass: (isUser) ? "msg_time" : "msg_time_send",
				who: isUser,
			}
			let afterHtml = null, beforeHtml = null;

			if (element.action) {
				switch (element.action) {
					case 'show-openings':
						beforeHtml = this.renderOpeningHours(element.parameters[0].openings);
						break;
					default: break;
				}
			}

			return element.message !== '' || beforeHtml !== null || afterHtml !== null ? (
				<div className="" key={"msg" + index}>
					<div className={msgVars.containerClass} style={msgVars.containerStyle}>
						{beforeHtml}
						<Linkify properties={{ target: '_blank' }}>{element.message}</Linkify>
						{afterHtml}
					</div>
				</div>) : null;
		}
	}

	renderOpeningHours(params) {
		const today = (new Date().getDay() - 1) % 7
		params = [0, 1, 2, 3, 4, 5, 6]
			.map(index => params[(index + today) % 7]);

		return [params.map((day, index) => Object.keys(day)
			.map(dayName => <p key={index} style={{ marginBottom: "5px", display: "inline-block", width: "100%" }}>
				{index === 0 ? <b style={{ float: "left", width: "45%" }}>{dayName} </b> : <span style={{ float: "left", width: "45%" }}>{dayName} </span>}
				{<span style={{ float: "right", width: "55%" }}>{day[dayName]}</span>}<span style={{ clear: "both" }}></span></p>)), <p style={{ clear: "both" }} key="-1"></p>]
	}
}

export default Message;